import { render, staticRenderFns } from "./ODMSample.vue?vue&type=template&id=955ecfa0&scoped=true&"
import script from "./ODMSample.vue?vue&type=script&lang=js&"
export * from "./ODMSample.vue?vue&type=script&lang=js&"
import style0 from "./ODMSample.vue?vue&type=style&index=0&id=955ecfa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955ecfa0",
  null
  
)

export default component.exports